import * as types from '../mutation-types'
import L from 'leaflet'

import { ETA_API } from '../../mixins/constants'
// const DEVIATION_RATE_TIME = 2.73;
const DISTANCE_NEAR_BY = 200 // meter
const INTERVAL_TIME_DURATION = 10000
const state = {
  supplierLocation: undefined,
  trackingSupplierLocationInterval: undefined,
  invalidOrderMode: false,
  supplierEta: undefined,
  trackingSupplierEtaInterval: undefined
}

const getDistancePoints = (fromPoint, toPoint) => {
  const fromLatLng = L.latLng(fromPoint.lat, fromPoint.lng)
  const toLatLng = L.latLng(toPoint.lat, toPoint.lng)
  const distance = fromLatLng.distanceTo(toLatLng)
  return distance
}
// Supplier Location
const trackingSupplierLocationHandler = async (message, commit) => {
  if (document.visibilityState !== 'visible' || !window.$mainWorker) {
    setTrackingLocationInterval(message, commit)
    return
  }

  const response = await window.$mainWorker.callAPI({ url: message.data.url })
  const { status, data } = response
  if (status === 200) {
    let location
    if (message.data.url.indexOf('/api/v3/private/aha-rent/order/locate_supplier') > -1) {
      location = data ? data : undefined
    } else {
      location = data && data.order_status ? data : undefined
    }
    commit(types.SET_SUPPLIER_LOCATION, location)
    setTrackingLocationInterval(message, commit)
  } else {
    commit(types.SET_SUPPLIER_LOCATION, undefined)
    commit(types.UPDATE_INVALID_ORDER_MODE_TO_GET_SUPPLIER_LOCATION, true)
    setTrackingLocationInterval(message, commit)
  }
}
const setTrackingLocationInterval = (message, commit) => {
  if (!state.trackingSupplierLocationInterval) {
    state.trackingSupplierLocationInterval = setInterval(() => {
      trackingSupplierLocationHandler(message, commit)
    }, INTERVAL_TIME_DURATION)
  }
}
//
//	Supplier estimated time of arrival
//
const trackingSupplierEtaHandler = async (commit, pickupPoint) => {
  if (state.supplierEta === 0) return
  if (document.visibilityState !== 'visible' || !state.supplierLocation || !window.$mainWorker) {
    setTrackingEtaInterval(commit, pickupPoint)
    return
  }
  const estimateDistance = getDistancePoints(state.supplierLocation, pickupPoint)
  // console.log("estimateDistance: ", estimateDistance);
  if (estimateDistance <= DISTANCE_NEAR_BY) {
    commit(types.SET_SUPPLIER_ETA, 0)
    return
  }

  const url = `${ETA_API}${state.supplierLocation.lng},${state.supplierLocation.lat};${pickupPoint.lng},${pickupPoint.lat}`
  const response = await window.$mainWorker.callAPI({ url: url })
  const { status, data } = response
  if (status === 200) {
    const route = data && data.routes && data.routes[0]
    // const eta =
    //   route.duration !== undefined
    //     ? Math.round((route.duration * DEVIATION_RATE_TIME) / 60)
    //     : undefined;
    let eta = route.duration !== undefined ? Math.round(route.duration / 60) : undefined
    if (eta && eta % 5 !== 0) {
      eta = Math.ceil(eta / 5) * 5
    }

    commit(types.SET_SUPPLIER_ETA, eta)
    setTrackingEtaInterval(commit, pickupPoint)
  } else {
    commit(types.SET_SUPPLIER_ETA, undefined)
    setTrackingEtaInterval(commit, pickupPoint)
  }
}
const setTrackingEtaInterval = (commit, pickupPoint) => {
  if (!state.trackingSupplierEtaInterval) {
    state.trackingSupplierEtaInterval = setInterval(() => {
      trackingSupplierEtaHandler(commit, pickupPoint)
    }, INTERVAL_TIME_DURATION)
  }
}
// getters
const getters = {
  supplierLocation: (state) => state.supplierLocation,
  trackingSupplierLocationInterval: (state) => state.trackingSupplierLocationInterval,
  invalidOrderModeToGetSupplierLocation: (state) => state.invalidOrderMode,
  supplierEta: (state) => state.supplierEta,
  trackingSupplierEtaInterval: (state) => state.trackingSupplierEtaInterval
}

// actions
const actions = {
  initTrackingSupplierLocation({ commit }, data) {
    const message = {
      name: 'call_api',
      data: {
        url: data.url
      }
    }
    trackingSupplierLocationHandler(message, commit)
  },
  stopTrackingSupplierLocation({ commit }) {
    commit(types.RESET_SUPPLIER_LOCATION)
  },
  initTrackingSupplierEta({ commit }, pickupPoint) {
    trackingSupplierEtaHandler(commit, pickupPoint)
  },
  stopTrackingSupplierEta({ commit }) {
    commit(types.RESET_SUPPLIER_ETA)
  },
  updateInvalidOrderMode({ commit }, value) {
    commit(types.UPDATE_INVALID_ORDER_MODE_TO_GET_SUPPLIER_LOCATION, value)
  },
  setSupplierETA({ commit }, value) {
    commit(types.SET_SUPPLIER_ETA, value)
  }
}

// mutations
const mutations = {
  [types.SET_SUPPLIER_LOCATION](state, location) {
    state.supplierLocation = location
  },
  [types.UPDATE_INVALID_ORDER_MODE_TO_GET_SUPPLIER_LOCATION](state, value) {
    state.invalidOrderMode = value
  },
  [types.RESET_SUPPLIER_LOCATION](state) {
    state.trackingSupplierLocationInterval && clearInterval(state.trackingSupplierLocationInterval)
    state.trackingSupplierLocationInterval = undefined
    state.supplierLocation = undefined
  },
  [types.SET_SUPPLIER_ETA](state, eta) {
    state.supplierEta = eta
  },
  [types.RESET_SUPPLIER_ETA](state) {
    state.trackingSupplierEtaInterval && clearInterval(state.trackingSupplierEtaInterval)
    state.trackingSupplierEtaInterval = undefined
    state.supplierEta = undefined
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
